"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateItemExists = exports.validateItemPlacement = exports.validateSectionExists = exports.validateSectionPlacement = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
function validateSectionPlacement(layout, index) {
    if (index === -1) {
        return true;
    }
    if (isEmpty_1.default(layout.sections) && !index) {
        return true;
    }
    // using <= here so that we can add to the last place not only by using -1 by also by using (lastIndex+1)
    return index <= layout.sections.length;
}
exports.validateSectionPlacement = validateSectionPlacement;
function validateSectionExists(layout, index) {
    return index > -1 && index < layout.sections.length;
}
exports.validateSectionExists = validateSectionExists;
function validateItemPlacement(section, index) {
    if (index === -1) {
        return true;
    }
    if (isEmpty_1.default(section.items) && !index) {
        return true;
    }
    // using <= here so that we can add to the last place not only by using -1 by also by using (lastIndex+1)
    return index <= section.items.length;
}
exports.validateItemPlacement = validateItemPlacement;
function validateItemExists(section, index) {
    return index > -1 && index < section.items.length;
}
exports.validateItemExists = validateItemExists;
//# sourceMappingURL=layoutValidation.js.map